export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const EDIT_AVATAR_SUCCESS = "EDIT_AVATAR_SUCCESS";
export const EDIT_AVATAR_FAIL = "EDIT_AVATAR_FAIL";
// Owner Types
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const CHECKIN_SUCCESS = "CHECKIN_SUCCESS";
export const CHECKIN_FAIL = "CHECKIN_FAIL";
export const GETALLCUSTOMERS_SUCCESS = "GETALLCUSTOMERS_SUCCESS";
export const GETALLCUSTOMERS_FAIL = "GETALLCUSTOMERS_FAIL";
export const SETROLE_SUCCESS = "SETROLE_SUCCESS";
export const SETROLE_FAIL = "SETROLE_FAIL";
export const GETOWNER_COUPONS_SUCCESS = "GETOWNER_COUPONS_SUCCESS";
export const GETOWNER_COUPONS_FAIL = "GETOWNER_COUPONS_FAIL";
export const OWNER_CONFIRM_SUCCESS = "OWNER_CONFIRM_SUCCESS";
export const OWNER_CONFIRM_FAIL = "OWNER_CONFIRM_FAIL";
// Customer Types
export const CUSTOMER_LOGIN_SUCCESS = "CUSTOMER_LOGIN_SUCCESS";
export const CUSTOMER_LOGIN_FAIL = "CUSTOMER_LOGIN_FAIL";
export const CUSTOMER_REGISTER_SUCCESS = "CUSTOMER_REGISTER_SUCCESS";
export const CUSTOMER_REGISTER_FAIL = "CUSTOMER_REGISTER_FAIL";
export const GETCUSTOMER_SUCCESS = "GETCUSTOMER_SUCCESS";
export const GETCUSTOMER_FAIL = "GETCUSTOMER_FAIL";
export const CUSTOMER_DELETE_SUCCESS = "CUSTOMER_DELETE_SUCCESS";
export const CUSTOMER_DELETE_FAIL = "CUSTOMER_DELETE_FAIL";
export const GETALLBUSINESS_SUCCESS = "GETALLBUSINESS_SUCCESS";
export const GETALLBUSINESS_FAIL = "GETALLBUSINESS_FAIL";
export const SET_SUCCESS_SUCCESS = "SET_SUCCESS_SUCCESS";
export const SET_SUCCESS_FAIL = "SET_SUCCESS_FAIL";
// Message Types
export const MESSAGE_SUCCESS = "MESSAGE_SUCCESS";
export const MESSAGE_FAIL = "MESSAGE_FAIL";
export const MESSAGE_SAVE_SUCCESSS = "MESSAGE_SAVE_SUCCESS";
export const MESSAGE_SAVE_FAIL = "MESSAGE_SAVE_FAIL";
export const COUPON_SEND_SUCCESS = "COUPON_SEND_SUCCESS";
export const COUPON_SEND_FAIL = "COUPON_SEND_FAIL";
export const COUPON_SAVE_SUCCESS = "COUPON_SAVE_SUCCESS";
export const COUPON_SAVE_FAIL = "COUPON_SAVE_FAIL";
export const COUPON_DELETE_SUCCESS = "COUPON_DELETE_SUCCESS";
export const COUPON_DELETE_FAIL = "COUPON_DELETE_FAIL";
export const COUPON_USE_SUCCESS = "COUPON_USE_SUCCESS";
export const COUPON_USE_FAIL = "COUPON_USE_FAIL";
